// Summary breakdown cards: the top five of each dimension with their share of
// sales and change. The whole card opens the full breakdown.
import { changeText, materialTone, money } from "./format";
import "./BreakdownCards.css";

export const CARDS = [
  { key: "product_category", title: "Category", noun: ["category", "categories"] },
  { key: "product", title: "Product", noun: ["product", "products"] },
  { key: "customer", title: "Customer", noun: ["customer", "customers"] },
  { key: "salesman", title: "Salesman", noun: ["salesman", "salesmen"] },
  { key: "route", title: "Route", noun: ["route", "routes"] },
  { key: "vendor", title: "Vendor", noun: ["vendor", "vendors"] },
  { key: "account_type", title: "Account type", noun: ["account type", "account types"] },
];
const PREVIEW = 5;

function Card({ card, rows, total, hasComparison, onOpen }) {
  const listed = rows.filter((row) => row.key !== "adjustment").sort((a, b) => Number(b.sales) - Number(a.sales));
  const noun = listed.length === 1 ? card.noun[0] : card.noun[1];
  return <button type="button" className="sa-card" aria-label={`${card.title}: view all ${listed.length} ${noun}`} onClick={() => onOpen(card.key)}>
    <span className="sa-card-head">
      <span className="sa-card-title">{card.title}</span>
      <span className="sa-card-count">{listed.length} {noun}</span>
    </span>
    {listed.length ? <span className="sa-card-rows">
      {listed.slice(0, PREVIEW).map((row) => {
        const share = total > 0 ? Math.max(0, Math.min(100, (Number(row.sales) / total) * 100)) : 0;
        return <span className="sa-card-row" key={row.key}>
          <span className="sa-card-line">
            <span className="sa-card-name" title={row.name}>{row.name || "Unassigned"}</span>
            <strong>{money(row.sales)}</strong>
          </span>
          <span className="sa-card-line">
            <span className="sa-card-share"><i style={{ width: `${share}%` }} /></span>
            {hasComparison && <span className={`sa-card-change sa-delta--${materialTone(row.change_amount, row.change_percent)}`}>
              {changeText(row.change_amount, row.change_percent)}</span>}
          </span>
        </span>;
      })}
    </span> : <span className="sa-card-empty">No sales in these dates</span>}
    <span className="sa-card-more">{listed.length > PREVIEW ? `View all ${listed.length} ${noun}` : "View details"}</span>
  </button>;
}

export default function BreakdownCards({ report, onOpen }) {
  const hasComparison = Boolean(report?.comparison);
  const total = Number(report?.summary?.total_sales || 0);
  return <section aria-labelledby="sa-cards-title">
    <h3 id="sa-cards-title" className="sa-section-title">Where the sales came from</h3>
    <div className="sa-cards">
      {CARDS.map((card) => <Card key={card.key} card={card} rows={report?.breakdowns?.[card.key] || []} total={total}
        hasComparison={hasComparison} onOpen={onOpen} />)}
    </div>
  </section>;
}
